import React from "react";
import s from "./styles.scss";
import {
  Router,
  Styled,
  RouterProps
} from "../../../toolkit/decorators/Artifact";
import BaseInput from "../../../toolkit/baseInput";
import { Container, Button } from "reactstrap";
import ReactTable from "react-table";
import columnsFactory from "./reactTable";
import ModalFrame from "../../../toolkit/modalFrame";
import ConfirmModal from "../common/confirmModal/confirmModal";
import { Preview } from "../../../types/IAction";
import {
  errorNotification,
  successNotification
} from "../../../utils/notifications";

interface Props extends RouterProps {
  conveniosList: any[];
  conveniosListLoading: boolean;
  getConveniosList: () => Promise<Preview<any>>;
  getConvenioMembresiasConteo: (idConvenio: number) => Promise<Preview<any>>;
  deleteConvenio: (idConvenio: number) => Promise<Preview<any>>;
  membresiaConteoLoading: boolean;
  membresiaConteo: any;
  membresiaConteoError: string;
  convenioDeleting: boolean;
  convenioDeletingError: string;
}

interface State {
  membresias: any[];
  count: number;
  isOpen: boolean;
  row: any;
  estatus: string;
}

@Router()
@Styled(s)
export default class ConveniosComponent extends React.Component<Props, State> {
  state = {
    membresias: [],
    count: -1,
    isOpen: false,
    row: null,
    estatus: "ACTIVO"
  };

  findMembresias = async row => {
    const preview = await this.props.getConvenioMembresiasConteo(row.id);

    if (preview.fulfilled) {
      this.setState({
        membresias: preview.membresiaConteo.membresias || [],
        count: preview.membresiaConteo.count,
        isOpen: true,
        row
      });
    } else {
      errorNotification(
        preview.membresiaConteoError ||
          "No se pudo obtener el conteo de membresías asociadas al convenio"
      );
    }
  };

  delete = async () => {
    const row = this.state.row;
    const preview = await this.props.deleteConvenio(row.id);

    if (preview.fulfilled) {
      this.props.getConveniosList();
      this.setState({ isOpen: false, count: -1 });
      successNotification("Convenio eliminado exitosamente");
    } else {
      errorNotification(
        preview.convenioDeletingError || "No se pudo eliminar el convenio"
      );
    }

    this.setState({ isOpen: false, count: -1 });
  };

  columns = columnsFactory(
    () => this.props.history.push("/cconvenios/configuracion"),
    row => this.props.history.push(`/cconvenios/${row.id}/configuracion`),
    row => this.findMembresias(row),
    s.actionHeaderIcon
  );

  getConveniosFiltered = () => {
    const { estatus } = this.state;
    if (!!estatus) {
      return [...this.props.conveniosList.filter(x => x.estatus == estatus)];
    } else {
      return [...this.props.conveniosList];
    }
  };

  render() {
    return (
      <Container>
        <ModalFrame
          title="Membresías en convenio"
          isOpen={this.state.isOpen && this.state.count > 0}
          toggle={() => this.setState({ isOpen: false, count: -1 })}
        >
          <p>
            {this.state.count > 1
              ? "Existen " + this.state.count + " membresías asociadas "
              : "Existe una membresía asociada "}
            al convenio y no se puede eliminar.
            {this.state.count > 1 ? " Por ejemplo:" : ""}
          </p>
          <div
            style={{
              background: "rgba(255, 255, 255, 0.8)",
              marginTop: "16px",
              width: "100%",
              fontSize: "0.9em"
            }}
          >
            <table className="table table-sm table-striped table-bordered">
              <thead>
                <tr>
                  <th>Club</th>
                  <th style={{ textAlign: "center" }}>Membresía</th>
                  <th>Cliente</th>
                </tr>
              </thead>
              <tbody>
                {this.state.membresias.map((m, i) => (
                  <tr key={"membc-" + i}>
                    <td>{m.club}</td>
                    <td style={{ textAlign: "center" }}>{m.idPublico}</td>
                    <td>{m.nombreCompleto}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </ModalFrame>
        <ConfirmModal
          isOpen={this.state.isOpen && this.state.count == 0}
          title={"Confirme la eliminación"}
          message={
            "¿Está seguro de eliminar el convenio? Esta acción no se puede deshacer."
          }
          ok={this.delete}
          cancel={() => this.setState({ isOpen: false, count: -1 })}
        />
        <div className="row">
          <div className="col-3">
            <BaseInput
              type="select"
              id="tipoFilter"
              name="tipoFilter"
              label={"Estatus"}
              value={this.state.estatus}
              options={[
                { value: "", label: "Seleccione un Tipo" },
                ...["ACTIVO", "INACTIVO"].map(option => ({
                  value: option,
                  label: option
                }))
              ]}
              onChange={e => {
                this.setState({
                  estatus: e.target.value
                });
              }}
            />
          </div>
          <div className="col-6">&nbsp;</div>
          <div className="col-3 mt-4">
            <Button
              className="primaryButton"
              onClick={e => {
                e.preventDefault();
                this.props.history.push("/empresas-convenios");
              }}
              size="sm"
              block
            >
              Empresas de convenio
            </Button>
          </div>
        </div>
        <ReactTable
          data={this.getConveniosFiltered()}
          columns={this.columns}
          className={`${s.customTable} mt-5 -striped -highlight`}
          sortable={false}
          resizable={true}
          showPagination={false}
          pageSize={
            (this.props.conveniosList || []).length < 5
              ? 5
              : this.props.conveniosList.length + 5
          }
        />
      </Container>
    );
  }
}
